import { createServerFn } from '@tanstack/react-start'
import { putBinaryToS3, getPresignedMediaUrl } from '../../lib/s3'
import { thumbKeyFor } from '../../lib/noteMedia'
import { uploadNoteMediaThumbSchema } from './mediaSchemas'

const MAX_THUMB_BYTES = 2 * 1024 * 1024

/** Store the poster thumbnail for an uploaded video at a deterministic key */
export const uploadNoteMediaThumb = createServerFn({ method: 'POST' })
  .inputValidator(uploadNoteMediaThumbSchema)
  .handler(async (ctx): Promise<{ key: string; url: string }> => {
    const body = Buffer.from(ctx.data.dataBase64, 'base64')
    if (body.length > MAX_THUMB_BYTES) {
      throw new Error('Thumbnail is too large')
    }
    const key = thumbKeyFor(ctx.data.forKey)
    await putBinaryToS3(key, body, 'image/jpeg')
    const url = await getPresignedMediaUrl(key)
    return { key, url }
  })
